module.exports = __webpack_public_path__ + "img/pay.80abcfd6.png";